import { types } from '../../../types/types';

export const reducerTraducoes = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.PESQUISA_TRADUCAO:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }
    return result;
}


export const traducoesNovaAtualizaReducer = (state = {}, action = {}) => {
    let result = {};
    switch (action.type) {
        case types.TRADUCAONOVOATUALIZA:
            result = action.payload;
            break;    
        default:
            result = state;
            break;
    }
    return result;
}